
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = {
  customer: {},
  error: null,
  passwordError: null,
  passwordLoading: false,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
